import React from 'react';
import { ArrowLeft } from 'lucide-react';


const AboutScreen = ({ onBack }) => {
  return (
    <div className="max-w-[480px] mx-auto pt-4 pb-8">
      {/* Top Bar */}
      <div className="flex items-center gap-3 mb-6">
        <button 
          className="p-2 bg-[#222] border border-[#2b2b2b] hover:bg-[#2b2b2b] rounded-lg text-gray-400 hover:text-white transition-all" 
          onClick={onBack}
        >
          <ArrowLeft size={18} />
        </button>
        <span className="text-[20px] font-medium text-white">About</span>
      </div>

      {/* Logo & Version */}
      <div className="flex flex-col items-center gap-2.5 mb-8 py-8 px-0">
        <div className="w-16 h-16 rounded-[16px] bg-[#6CD800] flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 448 512">
            <path d="M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 96l0 64 64 0 0-64L64 96zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm64 16l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm80 64l-64 0 0 64 64 0 0-64zM256 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-160zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z" fill="white"/>
          </svg>
        </div>
        <span className="text-[22px] font-bold text-white tracking-[0.5px]">FitScan</span>
        <span className="text-[12px] text-[#888] bg-[#181818] border-[0.5px] border-[#2b2b2b] rounded-[20px] px-3.5 py-1">Version 1.0.0</span>
      </div>

      {/* App Description */}
      <div className="text-[11px] font-medium text-[#888] uppercase tracking-[0.6px] mb-2">About FitScan</div>
      <div className="bg-[#101010] border-[0.5px] border-[#2b2b2b] rounded-[12px] p-4 mb-5">
        <p className="text-[13px] text-[#aaa] leading-[1.7] m-0">
          <strong className="text-white">FitScan</strong> is your all-in-one gym and fitness management platform, 
          built to simplify attendance tracking, monitor workout progress, and empower gyms 
          and users alike. Whether you're a gym owner managing hundreds of members or a 
          fitness enthusiast tracking your daily check-ins, FitScan has you covered.
        </p>
      </div>

      {/* Info Links */}
      <div className="text-[11px] font-medium text-[#888] uppercase tracking-[0.6px] mb-2">Information</div>
      <div className="bg-[#101010] border-[0.5px] border-[#2b2b2b] rounded-[12px] overflow-hidden mb-5">
        <div
          className="flex items-center gap-3 p-3.5 border-b-[0.5px] border-[#2b2b2b] last:border-b-0 cursor-pointer"
          onClick={() => window.open('/privacy', '_blank')}
        >
          <div className="w-9 h-9 rounded-[10px] flex items-center justify-center text-[16px] shrink-0 bg-[rgba(59,130,246,0.12)]">🛡️</div>
          <div className="flex flex-col">
            <div className="text-[13px] font-medium text-white">Privacy Policy</div>
            <div className="text-[11px] text-[#888] mt-0.5">How we handle your data</div>
          </div>
          <span className="ml-auto text-[12px] text-[#888]">›</span>
        </div>

        <div 
          className="flex items-center gap-3 p-3.5 border-b-[0.5px] border-[#2b2b2b] last:border-b-0 cursor-pointer"
          onClick={() => window.open('/privacy', '_blank')}
        >
          <div className="w-9 h-9 rounded-[10px] flex items-center justify-center text-[16px] shrink-0 bg-[rgba(251,191,36,0.12)]">📄</div>
          <div className="flex flex-col">
            <div className="text-[13px] font-medium text-white">Terms of Service</div>
            <div className="text-[11px] text-[#888] mt-0.5">Usage terms and conditions</div>
          </div>
          <span className="ml-auto text-[12px] text-[#888]">›</span>
        </div>
      </div>

      {/* Contact */}
      <div className="text-[11px] font-medium text-[#888] uppercase tracking-[0.6px] mb-2">Contact & Support</div>
      <div className="bg-[#101010] border-[0.5px] border-[#2b2b2b] rounded-[12px] overflow-hidden mb-5">
        <a 
          href="mailto:fitscan.official@gmail.com" 
          className="flex items-center gap-3 p-3.5 border-b-[0.5px] border-[#2b2b2b] last:border-b-0 no-underline transition-opacity hover:opacity-80"
        >
          <div className="w-9 h-9 rounded-[10px] flex items-center justify-center text-[16px] shrink-0 bg-[rgba(108,216,0,0.12)]">✉️</div>
          <div className="flex flex-col">
            <div className="text-[13px] font-medium text-white">Email Support</div>
            <div className="text-[11px] text-[#888] mt-0.5">support@fitscan.in</div>
          </div>
          <span className="ml-auto text-[12px] text-[#888]">›</span>
        </a>

        <div className="flex items-center gap-3 p-3.5 border-b-[0.5px] border-[#2b2b2b] last:border-b-0">
          <div className="w-9 h-9 rounded-[10px] flex items-center justify-center text-[16px] shrink-0 bg-[rgba(239,68,68,0.12)]">❤️</div>
          <div className="flex flex-col">
            <div className="text-[13px] font-medium text-white">Made with love</div>
            <div className="text-[11px] text-[#888] mt-0.5">By the FitScan Team</div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="text-center pt-6 pb-0 text-[11px] text-[#555] leading-[1.6]">
        <div className="w-10 h-[1px] bg-[#2b2b2b] mx-auto mb-3"></div>
        © {new Date().getFullYear()} FitScan. All rights reserved.
      </div>
    </div>
  );
};

export default AboutScreen;
